import { api } from '@/core/api/'

const apiUrl = 'api/edendiscipline'

export default {
  getReportAvailableAcademicYears() {
    return api.get(`${apiUrl}/reportavailableacademicyears`)
  },
  createEdenDisciplineReport(academicYearId) {
    return api.post(`${apiUrl}/createedendisciplinereport/${academicYearId}`)
  },
  getAvailableAcademicYears() {
    return api.get(`${apiUrl}/availableAcademicYears`)
  },
  getEdenDisciplines(params) {
    return api.get(`${apiUrl}/edendisciplines`, { params: params })
  },
  getDetail(edenDisciplineId) {
    return api.get(`${apiUrl}/detail?edenDisciplineId=${edenDisciplineId}`)
  },
  updateEdenDisciplineReport(id) {
    return api.put(`${apiUrl}/updateedendisciplinereport/${id}`)
  },
  submitReport(params) {
    return api.put(`${apiUrl}/submitmaster`, params)
  },
  generateFiles(edenMasterId) {
    return api.post(`${apiUrl}/generatefiles/${edenMasterId}`)
  },
  getFiles(edenMasterId) {
    return api.get(`${apiUrl}/files/${edenMasterId}`)
  },
  getFile(edenFileId) {
    return api.get(`${apiUrl}/file/${edenFileId}`)
  },
  deleteFiles(edenMasterId) {
    return api.delete(`${apiUrl}/files/delete/${edenMasterId}`)
  },
  searchDetail(params) {
    return api.post(`${apiUrl}/searchdetail`, params)
  },
  amendReport(params) {
    return api.post(`${apiUrl}/amendReport`, params)
  },
  publishPublicPortalData(edenMasterId) {
    return api.post(`${apiUrl}/publishpublicportaldata/${edenMasterId}`)
  },
}
